/**
 * System Settings Page
 * 
 * Platform-wide system configuration
 */

export default function SystemSettingsPage() {
  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h1 className="h3 fw-bold text-dark mb-1">System Settings</h1>
          <p className="text-muted mb-0">Platform configuration and settings</p>
        </div>
      </div>
      
      <div className="admin-card">
        <div className="card-body text-center py-5">
          <i className="bi bi-gear text-muted" style={{ fontSize: '4rem' }}></i>
          <h5 className="mt-3 text-muted">Coming Soon</h5>
          <p className="text-muted">System settings interface will be implemented here</p>
        </div>
      </div>
    </div>
  );
}